// Centralized contact information
// Update this file to change contact details across the entire website

export const contactInfo = {
  // Primary contact details
  phone: {
    primary: '+27 71 234 7546',
    display: '+27 71 234 7546',
    emergency: '+27 71 234 7546'
  },
  
  email: {
    primary: 'info@bioaxis.co.za',
    support: 'info@bioaxis.co.za',
    emergency: 'info@bioaxis.co.za',
    sales: 'info@bioaxis.co.za',
    privacy: 'info@bioaxis.co.za',
    legal: 'info@bioaxis.co.za'
  },
  
  // Business information
  business: {
    name: 'BioAxis',
    location: 'Pretoria, South Africa',
    address: {
      city: 'Pretoria',
      country: 'South Africa',
      full: 'Pretoria, South Africa'
    },
    hours: {
      weekdays: 'Mon - Fri: 08:00 - 17:00',
      weekend: 'Weekend: Emergency Support',
      timezone: 'SAST'
    }
  },
  
  // Support availability
  support: {
    phone: {
      availability: 'Mon-Fri 08:00-17:00 SAST',
      responseTime: 'Immediate'
    },
    email: {
      availability: 'Response within 2 hours',
      responseTime: '2 hours'
    },
    emergency: {
      availability: '24/7',
      responseTime: 'Immediate'
    }
  }
};

export default contactInfo; 